module.exports = __webpack_public_path__ + "static/childprotection_sec2_obj2@2x-9b1ada0bb57e25931b0fdbe4b855a831.png";